import Container from '@v2/shared/components/Container';
import icon1 from './images/icons/icon-1.svg';
import icon2 from './images/icons/icon-2.svg';
import icon3 from './images/icons/icon-3.svg';

type Feature = {
  icon: string;
  title: string;
  subhead: string;
};

/** Rendered in this order, which is not the order the icons are numbered in. */
const FEATURES: Feature[] = [
  {
    icon: icon3,
    title: 'Immediate digital access',
    subhead: 'Access your complete library with just one click. Save time, read digital.',
  },
  {
    icon: icon2,
    title: 'Read online & offline',
    subhead: 'Save your favorite titles to your device so you always have something to read.',
  },
  {
    icon: icon1,
    title: 'No commitment',
    subhead: 'Cancel your subscription anytime, no questions asked.',
  },
];

export default function FeaturesPanel() {
  return (
    <div className="flex justify-center w-full py-10 lg:pt-20 lg:pb-6 bg-white">
      <Container className="grid grid-cols-1 md:grid-cols-3 gap-10">
        {FEATURES.map((feature) => (
          <div key={feature.title} className="text-center py-4 xl:pb-20 xl:pt-16">
            <span className="inline-block mb-5">
              <img src={feature.icon} width={125} height={125} className="mb-5" alt="" />
            </span>
            {/* An h2 rather than the source's h1: the hero already carries this page's
                one h1, and headless emitted three more here. */}
            <h2 className="text-2xl lg:text-3xl font-bold mb-3">{feature.title}</h2>
            <p className="text-lg font-semibold max-w-xs mx-auto">{feature.subhead}</p>
          </div>
        ))}
      </Container>
    </div>
  );
}
